var currentPhone = '';
APP.init = function () {
  // Giả lập flow để đi qua page để account demo cho KH
  $(document).on('click', '#go-login', function () {
    $('.section__register').removeClass('active');
    $('.section__login').addClass('active');
  });

  // Giả lập flow để đi qua page để account demo cho KH
  $('#go-register').click(function () {
    $('.section__register--choice').removeClass('active');
    $('.section__register--target').addClass('active');
  });

  $(document).on('click', '.login-action', function () {
    $('#go-login').trigger('click');
  });
  // Checkbox Agree
  $('#chk_agree').change(function () {
    APP.loginValid();
  });

  $('#chk_age_confirmation').change(function () {
    APP.loginValid();
  });
    $('input[name="radioReceiveOtp"]').change(function () {
    APP.loginValid();
  });

  $(document).on('keyup', '#txtPhone', function () {
    APP.loginValid();
    if($(this).val() !== ''){
      $(this).parent().addClass('change_color');
    }else{
      $(this).parent().removeClass('change_color');
    }
  });

};

APP.loginValid = function() {
  var phone = APP.validText('#txtPhone');
  var vnf_regex = /^(0?)(3[2-9]|5[2|5|6|8|9]|7[0|6-9]|8[0-9]|9[0-4|6-9])[0-9]{7}$/;
  var phoneMobile = $('#txtPhone').val();
  var agree = $('#chk_agree').is(':checked') ? true : false;
  var age_confirmation = $('#chk_age_confirmation').is(':checked') ? true : false;
  var sendOTPVia = $('input[name="radioReceiveOtp"]:checked').val();
    if (phone && agree && age_confirmation && sendOTPVia && vnf_regex.test(phoneMobile) == true) {
    $("#loginSubmit").attr("disabled", false);
  } else {
    $("#loginSubmit").attr("disabled", true);
  }
}
APP.validText = function (byThis) {
  var result = true;
  if ($(byThis).val() === '') {
    result = false;
    $(byThis).removeClass("inputted");
  } else {
    $(byThis).addClass("inputted");
  }
  return result;
}

APP.loading = function (action="on") {
  if (action == 'on') {
    if (!$('.fs-loading').hasClass('active')) {
      $('.fs-loading').addClass('active');
    }
  } else {
    if ($('.fs-loading').hasClass('active')) {
      $('.fs-loading').removeClass('active');
    }
  }
}


APP.getNlbu = function() {
  return drupalSettings.nlbu;
}
APP.getNlcid = function() {
  return drupalSettings.nlcid;
}
